import {
    Button,
    Dialog,
    FormControl,
    FormControlLabel,
    FormLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from '@material-ui/core';
import React from 'react';
import { useState } from 'react';
import en from '../../../../lang/en-us';

const { dbCommercial, common } = en;

export default function MfCart(props: any) {
    const [paymentMode, setPaymentMode] = useState<string | null>(null);
    const [show, setShow] = useState<boolean>(false);
    const [value, setValue] = React.useState('otm');
    const [payment, setPayment] = useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };
    return (
        <div className="curved-bg mf-investment mf-cart">
            {/* Page-level title — single h1 for this route */}
            <h1 className="heading">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back"
                    onClick={() => props.history.goBack()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.goBack();
                        }
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                </a>
                {dbCommercial.ctLinks.newPurchase} - Lumpsum
            </h1>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    {/* Top-level section under page h1 */}
                    <h2>
                        <img src="/images/add-cart-icon.svg" alt="" aria-hidden="true" />
                        {dbCommercial.exploreMfs.mfCart.heading}(2)
                    </h2>
                    <div className="cart-investment-details">
                        {/* Subsection under "My Cart" */}
                        <h3>Lumpsum</h3>
                        <div className="cart-investment-details-info">
                            <div className="cart-investment-details-txt">
                                <p className="fund-name">
                                    <img src="/images/nippon-fav.png" alt="" />
                                    Nippon India Nifty Smallcap 250 Index Fund Dir Gr
                                </p>
                                <div className="cart-investment-details-bottom">
                                    <p>
                                        SIP Date <span>09</span> of every month
                                    </p>
                                    <p>
                                        Amount <span>₹ 5,000</span>
                                    </p>
                                </div>
                            </div>
                            <div className="icons">
                                <a>
                                    <img src="/images/edit-icon-filled.svg" alt="" />
                                </a>
                                <a>
                                    <img src="/images/delete-icon-filled.svg" alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="cart-investment-details">
                        {/* Parallel subsection to "Lumpsum" */}
                        <h3>SIP</h3>
                        <div className="cart-investment-details-info">
                            <div className="cart-investment-details-txt">
                                <p className="fund-name">
                                    <img src="/images/nippon-fav.png" alt="" />
                                    Nippon India Nifty Smallcap 250 Index Fund Dir Gr
                                </p>
                                <div className="cart-investment-details-bottom">
                                    <p>
                                        SIP Date <span>09</span> of every month
                                    </p>
                                    <p>
                                        Amount <span>₹ 5,000</span>
                                    </p>
                                </div>
                            </div>
                            <div className="icons">
                                <a>
                                    <img src="/images/edit-icon-filled.svg" alt="" />
                                </a>
                                <a>
                                    <img src="/images/delete-icon-filled.svg" alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="add-more-funds">
                        <Button className="customBtn">
                            +{dbCommercial.exploreMfs.mfCart.addMoreFunds}
                        </Button>
                    </div>
                </div>
                <div className="mf-investment-right">
                    {!payment ? (
                        <div className="cart-proceed">
                            <div className="heading">
                                {/* Right-panel section parallel to "My Cart (2)" — same level */}
                                <h2>
                                    {dbCommercial.exploreMfs.mfCart.cartDetails}{' '}
                                    <img src="/images/rupee-coin.png" alt="" aria-hidden="true" />
                                </h2>
                            </div>
                            <div className="schemes-added">
                                {/* Subsection under "Cart Details" */}
                                <h3 style={{ marginBottom: '10px', color: '#03614A' }}>
                                    2{dbCommercial.exploreMfs.mfCart.schemesAdded}{' '}
                                </h3>

                                <div className="schemes-added-info">
                                    <p>{dbCommercial.exploreMfs.mfCart.lumpsum}</p>
                                    <p className="scheme-count">
                                        1 {dbCommercial.exploreMfs.mfCart.scheme}
                                    </p>
                                </div>
                                <div className="schemes-added-info">
                                    <p>{dbCommercial.exploreMfs.mfCart.sip}</p>
                                    <p className="scheme-count">
                                        1 {dbCommercial.exploreMfs.mfCart.scheme}
                                    </p>
                                </div>
                                <div className="schemes-added-info total-scheme">
                                    <p>{dbCommercial.exploreMfs.mfCart.totalAmount}</p>
                                    <p className="scheme-count">₹ 10,000</p>
                                </div>
                            </div>
                            <Button className="customBtn" onClick={() => setPayment(!payment)}>
                                {dbCommercial.exploreMfs.mfCart.proceedToPay}
                            </Button>
                        </div>
                    ) : (
                        <div className="cart-payvia">
                            {/* Right-panel section parallel to "My Cart (2)" — same level */}
                            <h2>
                                <a
                                    role="button"
                                    tabIndex={0}
                                    aria-label="Back to cart details"
                                    onClick={() => setPayment(!payment)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setPayment(!payment);
                                        }
                                    }}
                                >
                                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                                </a>
                                {dbCommercial.exploreMfs.mfCart.amountPayable} <span>₹ 10,000</span>
                            </h2>
                            <FormControl component="fieldset" className="db-radio">
                                <FormLabel component="legend" id="pay-via">
                                    {dbCommercial.exploreMfs.mfPayment.payVia}
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="pay-via"
                                    value={value}
                                    onChange={handleChange}
                                >
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="otm"
                                            control={
                                                <Radio
                                                    name="pay-via-otm"
                                                    inputProps={{
                                                        'aria-label': `${dbCommercial.exploreMfs.mfPayment.otm} payment method`,
                                                        tabIndex: 0,
                                                        'aria-setsize': 3,
                                                        'aria-posinset': 1,
                                                    }}
                                                />
                                            }
                                            label={
                                                <>
                                                    <img
                                                        src="/images/net-banking.png"
                                                        alt="OTM payment icon"
                                                    />
                                                    {dbCommercial.exploreMfs.mfPayment.otm}
                                                </>
                                            }
                                        />
                                        <div className="reg-mode">
                                            <label
                                                htmlFor="reg-mode-sortby"
                                                id="reg-mode-visible-label"
                                                className="reg-mode-label"
                                            >
                                                {
                                                    dbCommercial.exploreMfs.mfPayment
                                                        .modeOfRegistration
                                                }
                                            </label>
                                            <div className="reg-mode-select">
                                                <FormControl
                                                    variant="filled"
                                                    className="mf-investment-select"
                                                >
                                                    <Select
                                                        labelId="reg-mode-visible-label"
                                                        id="reg-mode-sortby"
                                                        value="1"
                                                        aria-describedby="reg-mode-description"
                                                    >
                                                        <MenuItem value={1}>KOTM</MenuItem>
                                                    </Select>
                                                    <div
                                                        id="reg-mode-description"
                                                        className="sr-only"
                                                    >
                                                        Select mode of registration for payment
                                                    </div>
                                                </FormControl>
                                                <a onClick={() => setShow(!show)}>
                                                    + {dbCommercial.exploreMfs.mfPayment.addNew}
                                                </a>
                                            </div>
                                            <Button
                                                className="customBtn "
                                                onClick={() =>
                                                    props.history.push(
                                                        '/portal/commercial/mf-success',
                                                    )
                                                }
                                            >
                                                {dbCommercial.exploreMfs.mfPayment.payVia}OTM
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="upi"
                                            control={
                                                <Radio
                                                    name="pay-via-upi"
                                                    inputProps={{
                                                        'aria-label': `${dbCommercial.exploreMfs.mfPayment.upi} payment method`,
                                                        tabIndex: 0,
                                                        'aria-setsize': 3,
                                                        'aria-posinset': 2,
                                                    }}
                                                />
                                            }
                                            label={
                                                <>
                                                    <img
                                                        src="/images/upi.png"
                                                        alt="UPI payment icon"
                                                    />
                                                    {dbCommercial.exploreMfs.mfPayment.upi}
                                                </>
                                            }
                                        />
                                    </div>
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="net-banking"
                                            control={
                                                <Radio
                                                    name="pay-via-netbanking"
                                                    inputProps={{
                                                        'aria-label': `${dbCommercial.exploreMfs.mfPayment.netBanking} payment method`,
                                                        tabIndex: 0,
                                                        'aria-setsize': 3,
                                                        'aria-posinset': 3,
                                                    }}
                                                />
                                            }
                                            label={
                                                <>
                                                    <img
                                                        src="/images/net-banking.png"
                                                        alt="Net banking payment icon"
                                                    />
                                                    {dbCommercial.exploreMfs.mfPayment.netBanking}
                                                </>
                                            }
                                        />
                                    </div>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    )}
                </div>
            </div>
            <Dialog
                maxWidth={'sm'}
                open={show}
                aria-labelledby="newbank-mandate-modal"
                onClose={() => setShow(false)}
            >
                <div className="note-modals newbank-mandate-modal">
                    <h3 id="newbank-mandate-modal">
                        {dbCommercial.exploreMfs.mfPayment.modal.heading}
                    </h3>
                    <a onClick={() => setShow(!show)} className="close">
                        <img src="/images/close-black.svg" alt="" />
                    </a>
                    <div className="note-modals-content">
                        <div className="mandate-amount">
                            <TextField
                                label={dbCommercial.exploreMfs.mfPayment.modal.mandateAmount}
                                id="enter-arn"
                                variant="outlined"
                            />
                            <p>
                                <img src="/images/exclaim.svg" alt="" />
                                Valid From (Today)
                                <span>30-12-2021</span>
                            </p>
                        </div>
                        <FormControl variant="filled" className="bank-account-select">
                            <FormLabel
                                component="legend"
                                className="sr-only"
                                id="bank-account-legend"
                            >
                                {dbCommercial.exploreMfs.mfPayment.modal.bankAccount}
                            </FormLabel>
                            <Select
                                labelId="bank-account-label"
                                id="bank-account-select"
                                value="0"
                                aria-labelledby="bank-account-legend bank-account-label"
                                aria-describedby="bank-account-description"
                            >
                                <MenuItem value={0}>
                                    {dbCommercial.exploreMfs.mfPayment.modal.bankAccount}
                                </MenuItem>
                            </Select>
                            <div id="bank-account-description" className="sr-only">
                                Select bank account for payment
                            </div>
                        </FormControl>
                        <TextField
                            label={dbCommercial.exploreMfs.mfPayment.modal.ifsc}
                            id="enter-arn"
                            variant="outlined"
                        />
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => setShow(!show)}>
                                {dbCommercial.exploreMfs.mfPayment.modal.submit}
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
